import { render, staticRenderFns } from "./top_menu.vue?vue&type=template&id=a21747b4&scoped=true&"
import script from "./top_menu.vue?vue&type=script&lang=js&"
export * from "./top_menu.vue?vue&type=script&lang=js&"
import style0 from "./top_menu.vue?vue&type=style&index=0&id=a21747b4&lang=scss&scoped=true&"
import style1 from "./top_menu.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21747b4",
  null
  
)

export default component.exports